import React, { useEffect, useLayoutEffect, useState } from 'react';
import {
  useSpringRef,
  animated,
  useTransition,
  useSpring,
  config,
} from 'react-spring';
import styles from './ticker.module.css';
/* import coin from '../../assets/images/coin.png' */
import FlipCard from '../../components/FlipCard/FlipCard';

/*const CountDownTicker = React.memo((props) => {
  
  const springApi = useSpringRef();
  
  const springs = useSpring({
    from: {
      strokeDashoffset: 120,
      stroke:'#008000'
    },
    to: {
      strokeDashoffset: 0,
      stroke:'#ff9900'
    },
    config: {
      duration: props.duration? props.duration * 1000 : 5000,
    },
    loop: true,
    onRest:()=>{console.log("Animation Ended"); props.onEnd && props.onEnd()}
    //ref: springApi,
  })

  //const {strokeDashoffset} = springs;

  useEffect(()=>{
  },[springs])

  return(
    <div className={styles.ticker}>
      <div style={{display:'flex', alignItems:'center'}}><span><animated.div>{springs.strokeDashoffset.to(n => (n/120*props.duration).toFixed(0))}</animated.div></span></div>      
      <animated.svg
        width="40"
        height="40"
        viewBox="0 0 40 40"
        style={springs}>
        <path d="M19.9999 38.5001C17.5704 38.5001 15.1648 38.0216 12.9203 37.0919C10.6758 36.1622 8.63633 34.7995 6.91845 33.0816C5.20058 31.3638 3.83788 29.3243 2.90817 27.0798C1.97846 24.8353 1.49995 22.4296 1.49995 20.0002C1.49995 17.5707 1.97846 15.1651 2.90817 12.9206C3.83788 10.6761 5.20058 8.63663 6.91846 6.91875C8.63634 5.20087 10.6758 3.83818 12.9203 2.90847C15.1648 1.97876 17.5705 1.50024 19.9999 1.50024C22.4293 1.50024 24.835 1.97876 27.0795 2.90847C29.324 3.83818 31.3635 5.20088 33.0813 6.91876C34.7992 8.63663 36.1619 10.6761 37.0916 12.9206C38.0213 15.1651 38.4998 17.5707 38.4998 20.0002C38.4998 22.4296 38.0213 24.8353 37.0916 27.0798C36.1619 29.3243 34.7992 31.3638 33.0813 33.0816C31.3635 34.7995 29.324 36.1622 27.0795 37.0919C24.835 38.0216 22.4293 38.5001 19.9999 38.5001L19.9999 38.5001Z" />
      </animated.svg>
    </div>
  )
},(c, p)=>c.duration != c.duration);*/


const CountDownTicker = React.memo((props) => {
  
  //const springApi = useSpringRef();

  //console.log("DURATION", props.duration)

  const [flipped, setFlipped] = useState(false);

  const timeoutConst = React.useRef();

  const [springs,api] = useSpring(()=>({
    from: {
      strokeDashoffset: 120,
      stroke:'#008000'
    },
    to: {
      strokeDashoffset: 0,
      stroke:'#ff3300'
    },
    loop:true,
    //transform: `rotateX(${flipped ? 180 : 0}deg) translate(-50%, 0)`,
    //`perspective(600px) rotateX(${flipped ? 180 : 0}deg) translate(-50%, 0)`,
    onRest:handleOnRest,//()=>{},//{console.log("Animation Ended"); props.onEnd && props.onEnd()},
    config: { duration: props.duration? props.duration * 1000 : 5000},
  }))

  function handleOnRest() {
    api.pause();
      //timeoutConst.current = setTimeout(()=>{props.onEnd && props.onEnd();api.resume()}, 2000);
    props.onEnd && props.onEnd();
    console.log("Animation Ended");
  }

  useEffect(()=>
  {
    return ()=>{

      console.log("TIM", timeoutConst.current)

      if(timeoutConst.current)
      {
        //console.log("clearing timeout")
        clearTimeout(timeoutConst.current);
      }
    }
  }, []) 

  /* useEffect(()=>
  {
    setFlipped(props.refreshHash);
  }, [props.refreshHash]) */

  useEffect(()=>
  {
    console.warn("API", {u: api.update, d:props.duration})
    //api.update({config: { duration: 1000}})

    /* api.start({to: {
      strokeDashoffset: 0,
      stroke:'#ff9900'
    },config: { duration: 1000}}) */

  }, [props.duration])

 /*  function onEndHandler(){
    console.log("Animation Ended"); props.onEnd && props.onEnd()
  } */

  /*const [springs, api] = useSpring(()=>({
    from: {
      strokeDashoffset: 120,
      stroke:'#008000'
    },    
    config: {
      duration: props.duration? props.duration * 1000 : 5000,
    },
    loop: true,
    onRest:onEndHandler//()=>{console.log("Animation Ended"); props.onEnd && props.onEnd()}
    //ref: springApi,
  }))*/

  

  //const {strokeDashoffset} = springs;

  /*useEffect(()=>{

    console.warn("FROM", props.refreshHash)
    
    api.start({to: {
      strokeDashoffset: 0,
      stroke:'#ff9900'
    }})

  },[props.refreshHash])*/

  return(
    <div className={styles.ticker}>
      <div style={{display:'flex', alignItems:'center'}}><span>
        <animated.div style={{fontWeight:'bold',fontSize:20, color:springs.stroke.to(s=>s) }}>{springs.strokeDashoffset.to(n => (n/120*props.duration).toFixed(0))}</animated.div></span></div>      
        <animated.svg
          width="40"
          height="40"
          viewBox="0 0 40 40"
          style={springs}>
          <path strokeWidth="5" d="M19.9999 38.5001C17.5704 38.5001 15.1648 38.0216 12.9203 37.0919C10.6758 36.1622 8.63633 34.7995 6.91845 33.0816C5.20058 31.3638 3.83788 29.3243 2.90817 27.0798C1.97846 24.8353 1.49995 22.4296 1.49995 20.0002C1.49995 17.5707 1.97846 15.1651 2.90817 12.9206C3.83788 10.6761 5.20058 8.63663 6.91846 6.91875C8.63634 5.20087 10.6758 3.83818 12.9203 2.90847C15.1648 1.97876 17.5705 1.50024 19.9999 1.50024C22.4293 1.50024 24.835 1.97876 27.0795 2.90847C29.324 3.83818 31.3635 5.20088 33.0813 6.91876C34.7992 8.63663 36.1619 10.6761 37.0916 12.9206C38.0213 15.1651 38.4998 17.5707 38.4998 20.0002C38.4998 22.4296 38.0213 24.8353 37.0916 27.0798C36.1619 29.3243 34.7992 31.3638 33.0813 33.0816C31.3635 34.7995 29.324 36.1622 27.0795 37.0919C24.835 38.0216 22.4293 38.5001 19.9999 38.5001L19.9999 38.5001Z" />
        </animated.svg>
    </div>
  )
},(c, p)=> c.duration == p.duration && c.refreshHash == p.refreshHash && p.onEnd == c.onEnd)//,(c, p)=> true);//c.duration != c.duration || c.refreshHash == c.refreshHash);

export default CountDownTicker;
